import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { X, Check } from 'lucide-react';

const NovaRootsWay = () => {
 const beliefs = [
 'Children are natural learners who thrive when given agency and respect',
 'Mastery matters more than speed or comparison',
 'Real-world application deepens understanding',
 'Technology should support, not replace, human connection',
 'Learning happens best in calm, thoughtful environments',
 'Independence and critical thinking are foundational skills'
 ];

 const rejects = [
 'Exam-driven teaching that prioritises memorisation over understanding',
 'One-size-fits-all pacing that leaves some behind and others bored',
 'Learning disconnected from real life and application',
 'Schools designed around adult convenience rather than child development',
 'Ranking, comparison and competition as motivational tools',
 'Generic international curricula copied without cultural context'
 ];

 return (
 <div className="nova-way-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">The Nova Roots Way</h1>
 <p className="page-subtitle">
 Traditional schooling often fails children—not because teachers don't care, 
 but because the system itself is misaligned with how learning actually happens.
 </p>
 </div>
 </section>

 <section className="why-section">
 <div className="section-container">
 <h2 className="section-title">Why Traditional Schooling Falls Short</h2>
 <div className="why-content">
 <Card className="why-card">
 <CardContent className="why-card-content">
 <p>
 Most schools prioritise exam results over genuine understanding. They move all children 
 at the same pace, regardless of readiness. They separate learning from life, teaching 
 abstract concepts without real-world connection.
 </p>
 </CardContent>
 </Card>
 <Card className="why-card">
 <CardContent className="why-card-content">
 <p>
 Children spend years memorising information they'll never use, whilst missing essential 
 skills like financial literacy, critical thinking, and practical problem-solving. 
 The result? Learners who are stressed, disengaged, and unprepared for real life.
 </p>
 </CardContent>
 </Card>
 <Card className="why-card">
 <CardContent className="why-card-content">
 <p>
 Standardised testing narrows the curriculum, forcing teachers to teach to the test rather 
 than nurture curiosity and deep understanding. Children learn to perform for exams, 
 not to think independently or pursue genuine inquiry.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="beliefs-section">
 <div className="section-container">
 <h2 className="section-title">What Nova Roots Believes</h2>
 <div className="beliefs-grid">
 {beliefs.map((belief, index) => (
 <div key={index} className="belief-item">
 <div className="belief-icon">
 <Check size={20} />
 </div>
 <p>{belief}</p>
 </div>
 ))}
 </div>
 </div>
 </section>

 <section className="rejects-section">
 <div className="section-container">
 <h2 className="section-title">What We Deliberately Reject</h2>
 <div className="rejects-grid">
 {rejects.map((reject, index) => (
 <div key={index} className="reject-item">
 <div className="reject-icon">
 <X size={20} />
 </div>
 <p>{reject}</p>
 </div>
 ))}
 </div>
 </div>
 </section>

 <section className="approach-section">
 <div className="section-container">
 <h2 className="section-title">A Different Approach</h2>
 <div className="approach-content">
 <p className="approach-text">
 Nova Roots is not an international school. It's not a Montessori franchise. 
 It's not charity-led, and it's not exam-obsessed.
 </p>
 <p className="approach-text">
 We've built something new: a learning system that blends mastery-based academics, 
 thoughtful technology, real-world skills, and African-rooted design into a calm, 
 rigorous, future-facing education model.
 </p>
 <p className="approach-text">
 This is education designed for how children actually learn—not how institutions 
 find convenient to teach.
 </p>
 </div>
 </div>
 </section>
 </div>
 );
};

export default NovaRootsWay;